export interface ProfileAddressValues {
    address?: string;
    coordinates_lat?: number | string;
    coordinates_lon?: number | string;
    house_number?: string;
    street?: string;
    postcode?: string;
    city?: string;
    commune_code?: string;
}

export function buildAddressUpdatePayload(values: ProfileAddressValues) {
    return {
        address: values.address,
        coordinates_lat: values.coordinates_lat,
        coordinates_lon: values.coordinates_lon,
        house_number: values.house_number,
        street: values.street,
        postcode: values.postcode,
        city: values.city,
        commune_code: values.commune_code,
    };
}

export function buildProviderMyProfilePayload(
    values: ProfileAddressValues & { description?: string; travel_range?: number },
    options?: { includeAddress?: boolean; includeTravelRange?: boolean },
) {
    const providerPayload: Record<string, unknown> = {
        description: values.description ?? "",
    };

    if (options?.includeTravelRange && values.travel_range != null) {
        providerPayload.travel_range = values.travel_range;
    }

    const payload: Record<string, unknown> = {
        resources: {
            provider: providerPayload,
        },
    };

    if (options?.includeAddress) {
        Object.assign(payload, buildAddressUpdatePayload(values));
    }

    return payload;
}
